import PropTypes from 'prop-types';
import { ISODateValidator } from 'utilities/proptype-validators';

const SanityImageType = PropTypes.shape({
  alt: PropTypes.string.isRequired,
  asset: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
}).isRequired;

const SanityMerchImageType = PropTypes.shape({
  altText: PropTypes.string.isRequired,
  asset: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
}).isRequired;

const BlogPostDetailType = PropTypes.exact({
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  publishedAt: ISODateValidator,
  lastUpdated: ISODateValidator,
  title: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mainImage: SanityImageType,
  body: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  featuredKeyword: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.exact({ name: PropTypes.string.isRequired })
  ),
  category: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})),
}).isRequired;

const BlogPostTileType = PropTypes.exact({
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  publishedAt: ISODateValidator,
  title: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mainImage: SanityImageType,
  category: PropTypes.string.isRequired,
}).isRequired;

const LetterType = PropTypes.object;
const SiteStatsType = PropTypes.exact({
  lettersSent: PropTypes.number.isRequired,
  recurringDonors: PropTypes.number.isRequired,
  targetRecurringDonors: PropTypes.number.isRequired,
  users: PropTypes.number.isRequired,
  voterRegistrations: PropTypes.number.isRequired,
});

const PetitionType = PropTypes.exact({
  petition_code: PropTypes.string.isRequired,
  petitioner_code: PropTypes.string,
  subject: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  petitioner_name: PropTypes.string.isRequired,
  state: PropTypes.string,
  sent_timestamp: PropTypes.number.isRequired,
  target: PropTypes.string.isRequired,
  sign_count: PropTypes.number.isRequired,
  sign_status: PropTypes.oneOf(['open', 'closed']),
  trending: PropTypes.exact({
    sign_count_period: PropTypes.number,
  }).isRequired,
});

const PetitionTypeList = PropTypes.exact({
  petition_code: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  state: PropTypes.string,
  sent_timestamp: PropTypes.number.isRequired,
  target: PropTypes.string.isRequired,
  sign_count: PropTypes.number.isRequired,
  sign_status: PropTypes.oneOf(['open', 'closed']),
  trending: PropTypes.exact({
    sign_count_period: PropTypes.number,
  }),
});

const MerchType = PropTypes.exact({
  _id: PropTypes.string.isRequired,
  image: SanityMerchImageType,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
});

const KeywordType = PropTypes.shape({
  keyword: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.object),
});

export {
  BlogPostDetailType,
  BlogPostTileType,
  LetterType,
  SiteStatsType,
  PetitionType,
  PetitionTypeList,
  MerchType,
  SanityMerchImageType,
  KeywordType,
};
